export default {
   // Global
   tmpGlobalLayout: 'box',
   tmpHeaderHeight: '70px[a-b] 80px[c] 75px[d] 80px[e-f]',
   tmpHeadingBlockHeight: '90px',
   tmpTitleLgSize: '7',
   tmpTitleMdSize: '7[a-c] 5.5[d-f]',
   // Button
   tmpPrimaryButtonTextSize: '2',
   tmpSecondaryButtonTextSize: '2',
   tmpPrimaryButtonHeight: '44px[a-c] 38px[d] 44px[e-f]',
   tmpSecondaryButtonHeight: '40px[a-c] 38px[d] 40px[e-f]',
   // Spacing
   tmpSpacing: '25px[a-d] 30px[e] 40px[f]',
   tmpSpacingTop: '30px',
   // Viewport Constants
   tmpViewportHeight: `
      calc(100vh - 70px)[a-b]
      calc(100vh - 80px)[c]
      calc(100vh - 75px)[d]
      calc(100vh - 80px)[e-f]
   `,
   tmpContentFixedAreaHeight: `
      calc(100vh - 70px)[a-b]
      calc(100vh - 80px)[c]
      calc(100vh - 75px)[d]
      calc(100vh - 80px)[e-f]
   `,
   tmpViewportPadding: '20px[a] 20px[b] 40px[c] 30px[d] 5vw[e] calc(50vw - 850px + 150px)[f]',
   tmpViewportPaddingA: '20px',
   tmpViewportPaddingB: '20px',
   tmpViewportPaddingC: '40px',
   tmpViewportPaddingD: '30px',
   tmpViewportPaddingE: '5vw',
   tmpViewportPaddingF: 'calc(50vw - 850px + 150px)'
}
